export default "__VITE_ASSET__ypFElcVw__"